import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SnapchatIcon(props: IconProps) {
    return <Icon {...props} iconKey={"snapchat"}/>
}
